import checkin from "./checkin.json";
import customers from "./customers.json";
import dashboard from "./dashboard.json";
import digitalWallet from "./digitalWallet.json";
import events from "./events.json";
import financial from "./financial.json";
import helpCenter from "./helpCenter.json";
import marketing from "./marketing.json";
import people from "./people.json";
import registrations from "./registrations.json";
import reports from "./reports.json";
import sales from "./sales.json";
import settings from "./settings.json";
import terms from "./terms.json";
import common from "./common.json";

const translations = {
  ...checkin,
  ...customers,
  ...dashboard,
  ...digitalWallet,
  ...events,
  ...financial,
  ...helpCenter,
  ...marketing,
  ...people,
  ...registrations,
  ...reports,
  ...sales,
  ...settings,
  ...terms,
  ...common
};

export default translations;
